<template>
  <div :class="$style.container">
    <v-slide-x-reverse-transition>
      <Notification
        v-for="item in basketMessages"
        :key="item.id"
        v-bind="item"
        transition="v-slide-x-transition"
        :full-width="true"
        @remove="removeMessage"
      />
    </v-slide-x-reverse-transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import CONSTANTS from '@/js/plugins/store/modules/aimeos/constants'
import MUTATIONS from '@/js/plugins/store/modules/aimeos/mutation-types/basket-mutation-types.js'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import Notification from '@/js/components/Notifications/Notification.vue'

export default {
  name: 'BasketMessages',
  components: {
    Notification,
  },
  computed: {
    ...mapState(STOREMODULES.AIMEOS, {
      basketMessages: CONSTANTS.BASKET_MESSAGES,
    }),
  },
  methods: {
    ...mapMutations(STOREMODULES.AIMEOS, {
      removeMessage: MUTATIONS.REMOVE_BASKET_MESSAGE,
    }),
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
}
</style>
